<div
  class="menu-container"
  *ngIf="menuService.getActive()"
  [class]="themeService.getTheme()"
  (scroll)="onScroll($event)"
>
<!--  <div class="menu-container-content">-->
<!--    <div style="display: flex; flex-direction: column">-->
<!--      <div class="menu-item-container" style="display: flex; flex-direction: column;">-->
<!--        <div *ngFor="let block of elements[activeSection]?.blocks index as idx">-->
<!--          <div *ngIf="block.anotherType && block.type == 'about'">-->
<!--            <div class="menu-item-content" [style]="block.type == 'about' ? 'padding: 0;' : '' ">-->
<!--              <app-looped-slider [cards]="ImageCardsMenuArray" [grid]="grid"/>-->
<!--            </div>-->
<!--            <div class="menu-item-content-label menu-item-content-label-up">-->
<!--              <app-texts [texts]="labels[0].label"/>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div *ngIf="!block.anotherType">-->
<!--            <div class="menu-item-content" >-->
<!--              <app-menu-card-el/>-->
<!--              <div class="menu-item-content-label">-->
<!--                <app-texts [texts]="block.title ?? []"/>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
  <div class="menu-item-container" *ngIf="activeSection === 0">
    <div class="menu-item-content">
      <app-looped-slider [cards]="ImageCardsMenuArray" [grid]="grid"/>
    </div>
    <div class="menu-main-label">
      <app-texts [texts]="labels[0].label"/>
    </div>
  </div>
  <div *ngIf="activeSection > 0 && !loading" class="only-pc">
    <app-menu-vertical-slider
      [cards]="getArrayCards(activeSection)"
      [locations]="getArrayLocations(activeSection)"
      [menuIdx]="activeSection"
    />
  </div>
  <div class="only-mobile" *ngIf="activeSection > 0">
    <div class="mobile-menu-el">
      <div class="mobile-menu-el-text" *ngIf="!menuService.getMobileOverlay()">
        <app-texts [texts]="menuEls[activeSection - 1].title"/>
      </div>
      <div class="mobile-menu-el-button" *ngIf="!menuService.getMobileOverlay()" (click)="openUrl()">
        <app-texts [texts]="[{text:['исследовать', 'explore']}]"/>
      </div>
    </div>
  </div>
  <div class="mobile-overlay" *ngIf="menuService.getMobileOverlay()">
    <div class="mobile-overlay-el" (click)="goToHome()">
      <app-texts [texts]="[{text: ['Главная', 'Main']}]"  *ngIf="0 !== getActivePage()"/>
      <app-texts [texts]="[{text: ['Главная', 'Main'], fontFamily: 'pd', fontStyle: 'italic'}]" *ngIf="0 === getActivePage()"/>
    </div>
    <div *ngFor="let label of menuOverlayList index as i" class="mobile-overlay-el" (click)="openUrl(i)">
      <app-texts [texts]="label" *ngIf="i !== getActivePage()"/>
      <app-texts [texts]="menuOverlayListActive[getActivePage()]" *ngIf="i === getActivePage()"/>
    </div>
  </div>
  <div class="menu-container-menu">
    <div class="menu-container-menu-content">
      <div *ngFor="let item of menu; index as j"
           class="menu-container-menu-content-item menu-container-menu-content-item"
           (click)="goTo(j)"
      >
        <app-texts [texts]="item.menuLabelPd" *ngIf="activeSection == j"/>
        <app-texts [texts]="item.menuLabel" *ngIf="activeSection != j"/>
      </div>
    </div>
  </div>
</div>


<!--<div *ngIf="menuService.getMobileListMenu()" class="mobileMenu-list-container">-->
<!--  <div *ngFor="let item of menu; index as j"-->
<!--       class="menu-container-menu-content-item menu-container-menu-content-item"-->
<!--       [class]="{'menu-container-menu-content-item-active':-->
<!--           getActiveScreen() >= item.start && getActiveScreen() <= item.end }"-->
<!--       (click)="goTo(j)"-->
<!--  >-->
<!--    <app-texts [texts]="item.menuLabel"/>-->
<!--  </div>-->
<!--</div>-->
